export enum StateSliceName {
  Automations = 'Automations',
  AppointmentsModal = 'AppointmentsModal',
  Board = 'Board',
  Conversations = 'Conversations',
  PaymentSettings = 'PaymentSettings',
  MergeProfiles = 'MergeProfiles',
  CareWizardSteps = 'CareWizardSteps',
  User = 'User',
  CurrentClinic = 'CurrentClinic',
  Phone = 'Phone',
}
